import {
    INITIAL_STATE,
    setTeamMembership,
    updateTeamMembership,
    disableTeamMember,
    deleteTeamMember,
    setTeamInvites,
    updateTeamInvites,
    deleteTeamInvite,
} from '../core'
import {
    RECEIVE_TEAM_MEMBERS,
    RECEIVE_TEAM_INVITES,
} from '../action_creators'

function selectedTeamMembership(state=INITIAL_STATE.selectedTeamMembership, action) {
    switch (action.type) {
        case RECEIVE_TEAM_MEMBERS:
            return setTeamMembership(state,
                action.teamId,
                action.teamMembers.map( (raw) => {
                    return { ...raw, id: raw.userId }
                }))
        case 'RECEIVE_MEMBER':
            return updateTeamMembership(state, action.member)
        case 'REMOVE_MEMBER':
            return deleteTeamMember(state, action.member)
        case 'DISABLE_MEMBER':
            return disableTeamMember(state, action.member)
        default:
            return state
    }
}

function selectedTeamInvites(state=INITIAL_STATE.selectedTeamInvites, action) {
    switch (action.type) {
        case RECEIVE_TEAM_INVITES:
            return setTeamInvites(state,
                action.teamId,
                action.teamInvites.map( raw => {
                    return { ...raw }
                }))
        case 'RECEIVE_INVITE':
            return updateTeamInvites(state, action.invite)
        case 'REMOVE_INVITE':
            return deleteTeamInvite(state, action.inviteId)
        default:
            return state
    }
}

export {
    selectedTeamMembership,
    selectedTeamInvites,
}



// WEBPACK FOOTER //
// ./src/redux/reducers/team_membership_reducer.js